import React, { ReactNode } from 'react';

import classNames from 'classnames';
import TransparentCard from '@/components/shared/card/TransparentCard';

interface HeroTransparentCardLayoutProps {
  children: ReactNode;
  heading?: string | ReactNode;
}

const HeroTransparentCardLayout = ({ children, heading }: HeroTransparentCardLayoutProps) => {
  return (
    <div className={classNames('w-full relative text-center px-8 md:px-0 max-w-xl')}>
      {heading && (
        <h1
          data-cy="home-hero-authentication-heading"
          className="!mb-6 text-white text-center sm:mx-4 text-2xl [&_strong]:text-blue-lighter"
        >
          {heading}
        </h1>
      )}
      <TransparentCard>{children}</TransparentCard>
    </div>
  );
};

export default HeroTransparentCardLayout;
